exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.score{transition:padding .5s}div.score.editing{border:1px dashed #94ce56;padding:2rem 0;background:rgba(38,150,132,.15)}.theme-hot div.score.editing{border-color:#e06b1e;background:rgba(150,113,38,.15)}.theme-white div.score.editing{background:#fff}.score button{width:35%;margin:0 .5rem 1.5rem;font-weight:700}.score button.miss{width:90%}.score button{color:#d1ffd2}", ""]);

// exports
